import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from "@mui/material/Card";
import CardContent from '@mui/material/CardContent';
import { useTranslation } from "react-i18next";
function VendorDetails(props) {

  const { t }     = useTranslation();
  let pageContent = props.pageContent;

  return (
    <Grid item xs={6}>
    <Card mb={2} variant="outlined" sx={{height: "310px"}}>
      <CardContent>
        <Grid item xs={12} my={2}>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            {t('Seller Details')}
          </Typography>          
        </Grid>
        <Grid container spacing={0} mt={1}>
          <Grid item xs={12}>
            <Typography sx={{ fontSize: 14 }} component="div" gutterBottom>
              <Box className="addressBox">
                  <div className="addressBoxLeft">{t('Seller Name')}</div>
                  <div className="addressBoxMiddle">:</div>
                  <div className="addressBoxRight">
                    {pageContent.vendorDetails.vendorName ? pageContent.vendorDetails.vendorName : '-'}
                  </div>
              </Box>  
            </Typography>
            <Typography sx={{ fontSize: 14 }} component="div" gutterBottom>
              <Box className="addressBox">
                  <div className="addressBoxLeft">{t('Seller Shop Name')}</div>
                  <div className="addressBoxMiddle">:</div>
                  <div className="addressBoxRight">
                    {pageContent.vendorDetails.vendorShopName ? pageContent.vendorDetails.vendorShopName : '-'}
                  </div>
              </Box>  
            </Typography>
            <Typography sx={{ fontSize: 14 }} component="div" gutterBottom>
              <Box className="addressBox">
                  <div className="addressBoxLeft">{t('Seller Email')}</div>
                  <div className="addressBoxMiddle">:</div>
                  <div className="addressBoxRight">
                    {pageContent.vendorDetails.vendorEmail ? pageContent.vendorDetails.vendorEmail : '-'}
                  </div>
              </Box>  
            </Typography>
          </Grid>
        </Grid>                   
      </CardContent>  
    </Card> 
  </Grid>  
  )
}

export default VendorDetails;